import { render, staticRenderFns } from "./PaymentHistoryStudent.vue?vue&type=template&id=18bfb923&scoped=true&"
import script from "./PaymentHistoryStudent.vue?vue&type=script&lang=js&"
export * from "./PaymentHistoryStudent.vue?vue&type=script&lang=js&"
import style0 from "./PaymentHistoryStudent.vue?vue&type=style&index=0&id=18bfb923&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bfb923",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VDataTable,VDivider,VSnackbar,VToolbar,VToolbarTitle})
